// Dock layout utilities: enumerate six modes and provide width constraints

export const DOCK_LAYOUT = Object.freeze({
  SPLIT_RL: 'split_rl',      // Edit left, AI right
  SPLIT_LR: 'split_lr',      // AI left, Edit right
  RIGHT_ABOVE: 'right_above', // Right side, AI above Edit
  RIGHT_BELOW: 'right_below', // Right side, AI below Edit
  LEFT_ABOVE: 'left_above',   // Left side, AI above Edit
  LEFT_BELOW: 'left_below',   // Left side, AI below Edit
});

// For each mode, describe side activation and stacking order
// side: 'left' | 'right' | 'both'
// order: ['ai','edit'] or ['edit','ai'] when side is single; when both, order implies which panel on which side
export const DOCK_LAYOUT_SPECS = Object.freeze({
  [DOCK_LAYOUT.SPLIT_RL]: {
    sides: { left: 'edit', right: 'ai' },
    label: 'Edit left, AI right',
  },
  [DOCK_LAYOUT.SPLIT_LR]: {
    sides: { left: 'ai', right: 'edit' },
    label: 'AI left, Edit right',
  },
  [DOCK_LAYOUT.RIGHT_ABOVE]: {
    sides: { right: ['ai', 'edit'] },
    label: 'Right: AI above Edit',
  },
  [DOCK_LAYOUT.RIGHT_BELOW]: {
    sides: { right: ['edit', 'ai'] },
    label: 'Right: Edit above AI',
  },
  [DOCK_LAYOUT.LEFT_ABOVE]: {
    sides: { left: ['ai', 'edit'] },
    label: 'Left: AI above Edit',
  },
  [DOCK_LAYOUT.LEFT_BELOW]: {
    sides: { left: ['edit', 'ai'] },
    label: 'Left: Edit above AI',
  },
});

// Width constraints helpers (desktop defaults)
export const AI_MIN_WIDTH_PX = 240;
export const AI_MAX_WIDTH_VW = 0.30; // 30% of viewport

export const EDIT_MIN_WIDTH_PX = 340;
export const EDIT_MAX_WIDTH_VW = 0.90; // 85-90%, using 90% cap here

export function clampAIPaneWidth(widthPx, viewportWidth) {
  if (!viewportWidth || viewportWidth <= 0) return widthPx;
  const min = AI_MIN_WIDTH_PX;
  const max = Math.max(min, Math.floor(viewportWidth * AI_MAX_WIDTH_VW));
  return Math.min(Math.max(widthPx, min), max);
}

export function clampEditPaneWidth(widthPx, viewportWidth) {
  if (!viewportWidth || viewportWidth <= 0) return widthPx;
  const min = EDIT_MIN_WIDTH_PX;
  const max = Math.max(min, Math.floor(viewportWidth * EDIT_MAX_WIDTH_VW));
  return Math.min(Math.max(widthPx, min), max);
}

export function getDefaultSidebarOpen(layout) {
  // Returns { left: boolean, right: boolean }
  switch (layout) {
    case DOCK_LAYOUT.SPLIT_RL:
      return { left: true, right: true };
    case DOCK_LAYOUT.SPLIT_LR:
      return { left: true, right: true };
    case DOCK_LAYOUT.RIGHT_ABOVE:
    case DOCK_LAYOUT.RIGHT_BELOW:
      // Left closed (no pane on left), right open
      return { left: false, right: true };
    case DOCK_LAYOUT.LEFT_ABOVE:
    case DOCK_LAYOUT.LEFT_BELOW:
      // Left open, right stays open to preserve current UX
      return { left: true, right: true };
    default:
      return { left: true, right: true };
  }
}

export function isValidDockLayout(layout) {
  return Object.values(DOCK_LAYOUT).includes(layout);
}


